import { render, staticRenderFns } from "./Telesales.vue?vue&type=template&id=0b1fce50&"
import script from "./Telesales.vue?vue&type=script&lang=ts&"
export * from "./Telesales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports